import Actions from "../consts";
import InitialState from "../intial.state";

export const application = (state = InitialState.application, action: any = {}) => {
    switch (action.type) {
        case Actions.SET_CURRENT_LANGUAGE:
            if (action.payload !== "en" && action.payload !== "es") return state;
            return {...state, currentLanguage: action.payload};
        case Actions.AUTHORISE:
            return {...state, authorise: true, user: action.payload};
        case Actions.UN_AUTHORISE:
            const tempSession = action.payload.tempSession
            return {...state, authorise: false, user: null, tempSession};
        case Actions.APP_LOADING:
            return {...state, loading: action.payload};
        default:
            return state;
    }
};
